import React, {useEffect, useState} from 'react';
import {
  Container,
  CardHeader,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input, Tooltip, Col
} from 'reactstrap';
import Card from "../PurpleTheme/Card";
import {useDispatch, useSelector} from "react-redux";
import {
  createDaemon,
  getAllTokens,
  refreshDaemonAccessToken,
  updateDaemonTokenDetails
} from "../../store/daemon/actions";
import {getOrganization as onGetOrganization} from "../../store/organization/actions";
import TokenModal from "../../pages/DaemonDetails/TokenModal";
import * as PropTypes from "prop-types";
import Switch from "react-switch";
import {getLocalDateTime} from "../../helpers/component_helpers";
const TokenManagementPreview = () => {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);
  const [enableDisableModalOpen, setEnableDisableModalOpen] = useState(false);
  const [tokenModalOpen, setTokenModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [newTokenName, setNewTokenName] = useState('');
  const [tokenToDelete, setTokenToDelete] = useState(null);
  const [tTop, setTop] = useState(false);
  const {available_tokens, isGenerating} = useSelector(state => ({
    available_tokens: state.Daemon.available_tokens,
    isGenerating: state.Daemon.isGenerating || false
  }));
  const {daemon_token_details} = useSelector(state => ({
    daemon_token_details: state.Daemon.daemon_token_details
  }))
  const [tokens, setTokens] = useState(available_tokens || []);

  useEffect(() => {
    dispatch(getAllTokens())
  }, [])

  useEffect(() => {
    dispatch(onGetOrganization());
  }, [])

  function toggle_modal() {
    if (modalOpen) {
      setModalOpen(false)
    } else {
      setModalOpen(true);
    }
  }

  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 10,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 10,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };


  const {organizationDetails} = useSelector(state => ({
    organizationDetails: state.Organization.organization || [],
  }));

  useEffect(() => {
      setTokens(available_tokens);
  }, [available_tokens.length]);


  const handleDeleteToken = (token) => {
    setTokenToDelete(token);
    setDeleteModalOpen(true);
  };

  const confirmDeleteToken = () => {
    if (tokenToDelete){
      let payload = {
        token_id: tokenToDelete.id,
        delete_token : true
      }
      setDeleteModalOpen(false)
      setTokenToDelete(null)
      dispatch(updateDaemonTokenDetails(payload));
    }
  };

  const handleToggleTokenStatus = (token) => {
    let payload = {
      token_id: token.id,
      enabled: !token.enabled
    }
    setEnableDisableModalOpen(false);
    setSelectedToken(null);
    dispatch(updateDaemonTokenDetails(payload));
  };

  const toggleEnableDisableModal = (token) => {
    setSelectedToken(token);
    setEnableDisableModalOpen(prevState => !prevState);
  }

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('Token copied to clipboard!');
    } catch (error) {
      console.error('Failed to copy token:', error);
    }
  };

  function toggleCreateToken() {
    setTokenModalOpen(prevState => !prevState);

  }

  function handleGenerateToken() {
    if (organizationDetails?.daemon_onboarded) {
      let payload = {
        token_name: newTokenName,
      }
      dispatch(refreshDaemonAccessToken(payload))
    } else {
      let payload = {
        token_name: newTokenName,
        name:'Daemon'
      }
      dispatch(createDaemon(payload))
    }
    setModalOpen(true);
    setTokenModalOpen(false);
  }

  function handleCancelCreateToken() {
    setTokenModalOpen(false);
    setNewTokenName('')
  }

  const [tooltipStates, setTooltipStates] = useState({});

// Helper functions to manage individual tooltip states
  const setTooltipOpen = (tokenId, isOpen) => {
    setTooltipStates(prev => ({
      ...prev,
      [tokenId]: isOpen
    }));
  };

  return (
    <Container fluid className="py-4">
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0">Access Tokens</h5>
          <Button color="primary" onClick={toggleCreateToken}>
            <i className="bx bx-plus mr-2"></i>
            Generate New Token
          </Button>
        </CardHeader>
        <CardBody>
          <div>
            <table className="table-purple-org table-sm">
              <thead>
              <tr>
                <th>
                  <div className="d-flex justify-content-center">
                    <small>Token Name</small>
                  </div>
                </th>
                <th>
                  <div className="d-flex justify-content-center">
                    <small>Access Key</small>
                  </div>
                </th>
                <th>
                  <div className="d-flex justify-content-center">
                    <small>Last Used</small>
                  </div>
                </th>
                <th>
                  <div className="d-flex justify-content-center">
                    <small>Status</small>
                  </div>
                </th>
                <th>
                  <div className="d-flex justify-content-center">
                    <small>Action</small>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              {tokens.map((token) => {
                return (
                  <tr key={token.id}>
                    <td className="py-2">
                      <div className="d-flex align-items-center justify-content-center">
                        <div>
                          <div className="font-weight-bold text-truncate" style={{ maxWidth: '120px' }}>
                            {token.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="py-2">
                      <code className="p-1 rounded justify-content-center d-flex small text-truncate" style={{ maxWidth: '150px' }}>
                        {token.api_key}
                      </code>
                    </td>
                    <td className="py-2">
                      <div className="d-flex align-items-center justify-content-center">
                        <div>
                          <div className="font-weight-bold">
                            <small>{getLocalDateTime(token.last_used_at)}</small>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="align-middle text-center py-2">
                      <div className="d-flex justify-content-center align-items-center">
                        <div
                          id={`tooltip-${token.id}`}
                          onMouseOver={() => setTooltipOpen(token.id, true)}
                          onMouseLeave={() => setTooltipOpen(token.id, false)}
                          className="alert-icon d-flex justify-content-center align-items-center"
                        >
                          <Switch
                            uncheckedIcon={<OffSymbol />}
                            checkedIcon={<OnSymbol />}
                            className="me-1"
                            height={14}
                            width={32}
                            handleDiameter={12}
                            onColor="#34c38f"
                            offColor="#f46a6a"
                            boxShadow="0px 1px 2px rgba(0, 0, 0, 0.3)"
                            activeBoxShadow="0px 0px 1px 2px"
                            onChange={() => toggleEnableDisableModal(token)}
                            checked={token.enabled}
                          />
                        </div>
                        <Tooltip
                          placement="top"
                          isOpen={tooltipStates[token.id] || false}
                          target={`tooltip-${token.id}`}
                          toggle={() => setTooltipOpen(token.id, !tooltipStates[token.id])}
                          style={{
                            border: "2px solid #f1b44c",
                            borderRadius: "8px",
                            backgroundColor: "#2a3042",
                            fontSize: "0.75rem",
                            zIndex: 1
                          }}
                        >
                          Enable or Disable this token
                        </Tooltip>
                      </div>
                    </td>
                    <td className="py-2">
                      <div className="d-flex align-items-center justify-content-center">
                        <Button
                          onClick={() => handleDeleteToken(token)}
                          color="link"
                          className="text-danger p-1"
                          title="Delete Token"
                          size="sm"
                          style={{
                            fontSize: '1rem',
                            lineHeight: 1,
                            width: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <i className="mdi-delete mdi"></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>


      {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
        <ModalHeader toggle={() => setDeleteModalOpen(false)}>
          <div className="d-flex align-items-center">
            <span>Delete Token</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <h5 className="font-weight-bold mb-3">Are you sure?</h5>
          <p>
            You're about to delete the token "<strong>{tokenToDelete?.name}</strong>".
            This action cannot be undone and will immediately revoke access for any daemons using this token.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setDeleteModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={confirmDeleteToken}
          >
            Delete Token
          </Button>
        </ModalFooter>
      </Modal>


      {/* Enable/Disable Confirmation Modal */}
      <Modal isOpen={enableDisableModalOpen} toggle={() => setEnableDisableModalOpen(false)}>
        <ModalHeader toggle={() => setEnableDisableModalOpen(false)}>
          <div className="d-flex align-items-center">
            <span>{selectedToken?.enabled ? 'Disable' : 'Enable'} Token</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <h5 className="font-weight-bold mb-3">Are you sure?</h5>
          <p>
            You&#39;re about to {selectedToken?.enabled ? 'disable' : 'enable'} the token
            &nbsp;<strong>{selectedToken?.name}</strong>.
            {selectedToken?.enabled
              ? ' This will immediately revoke access for any daemons using this token.'
              : ' This will allow daemons to use this token again.'}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setEnableDisableModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            color={selectedToken?.enabled ? 'warning' : 'success'}
            onClick={() => {
              if (selectedToken) handleToggleTokenStatus(selectedToken);
            }}
          >
            {selectedToken?.enabled ? 'Disable Token' : 'Enable Token'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Token Generation Modal */}
      <Modal isOpen={tokenModalOpen} toggle={toggleCreateToken}>
        <ModalHeader toggle={toggleCreateToken}>Generate New Token</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="tokenName">Token Name (optional)</Label>
            <Input
              id="tokenName"
              type="text"
              value={newTokenName}
              onChange={e => setNewTokenName(e.target.value)}
              placeholder="Enter token name"
              disabled={isGenerating}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCancelCreateToken} disabled={isGenerating}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleGenerateToken}
            disabled={isGenerating}
          >
            {isGenerating ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" />
                Generating...
              </>
            ) : (
              'Generate'
            )}
          </Button>
        </ModalFooter>
      </Modal>
      <TokenModal toggle={toggle_modal} isOpen={modalOpen} token={daemon_token_details?.token}/>
    </Container>
  );
};

export default TokenManagementPreview;